import Container from 'react-bootstrap/Container';

export function QuickBuilder() {
    // Some logic goes here

    return (
        <Container className="QuickBuilder">
            <br />
            <h1>Quick Builder</h1>
            <br />
        </Container>
    );
}
